export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "brief_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mon brief quotidien"])},
        "region_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Région ", _interpolate(_named("name"))])},
        "sales_yesterday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ventes hier"])},
        "sales_this_month": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ventes ce mois"])},
        "active_stores": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasins actifs ce mois"])},
        "objective_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objectif de la région"])},
        "select_region": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner une région"])},
        "download_brief": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Télécharger le brief"])},
        "top_stores_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Top 5 magasins région"])},
        "top_sellers_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Top 5 vendeurs région"])}
      },
      "en": {
        "brief_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My daily brief"])},
        "region_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Region ", _interpolate(_named("name"))])},
        "sales_yesterday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales yesterday"])},
        "sales_this_month": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales this month"])},
        "active_stores": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active stores this month"])},
        "objective_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region objective"])},
        "select_region": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a region"])},
        "download_brief": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download brief"])},
        "top_stores_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Top 5 regional stores"])},
        "top_sellers_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Top 5 regional sellers"])}
      }
    }
  })
}
